import {pullRequestPath} from '@github-ui/paths'
import {useMutation} from '@github-ui/react-query'
import {reactFetch} from '@github-ui/verified-fetch'
import {Button} from '@primer/react'

import {useLayoutQuery} from '../../../../page-data/loaders/use-layout-query'
import {useOverviewRouteData} from '../../data/use-overview-route-data'

export function RevertPRAction() {
  const {pullRequest, repository} = useLayoutQuery().data
  const {user} = useOverviewRouteData().data
  const revertPath =
    pullRequest?.number && repository?.name
      ? `${pullRequestPath({repo: repository, number: pullRequest.number})}/revert`
      : ''

  const revertMutation = useMutation({
    mutationFn: async () => {
      const response = await reactFetch(revertPath, {method: 'POST'})
      if (!response.ok) throw new Error(`Failed to revert pull request: ${response.status}`)
      return response.url
    },
    onSuccess: targetUrl => {
      if (targetUrl) window.location.assign(targetUrl)
    },
  })

  if (!revertPath || !user?.canRevert) return null

  return (
    <Button
      size="small"
      loading={revertMutation.isPending}
      loadingAnnouncement="Opening revert pull request"
      onClick={() => revertMutation.mutate()}
    >
      Revert
    </Button>
  )
}
